export default __webpack_public_path__ + "static/media/me.f2c05551.png";